import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1dd842b4"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd842b4')) {
      api.createRecord('1dd842b4', component.options)
    } else {
      api.reload('1dd842b4', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1dd842b4", function () {
      api.rerender('1dd842b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datasourceconfig/list.vue"
export default component.exports